import { useMutation, useQueryClient } from '@tanstack/react-query';

import { type PolicyDetails } from '~entities/policies/index';

import { baseAPI } from '~shared/api/base-api';

interface BulkDeletePoliciesParams {
  policyIds: Array<string>;
}

export const bulkDeletePoliciesAPI = async (
  params: BulkDeletePoliciesParams,
) => {
  const response = await baseAPI.delete<Array<PolicyDetails>>(
    '/policies/batch/all',
    {
      data: params.policyIds,
    },
  );
  return response.data;
};

export const useBulkDeletePolicies = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (params: BulkDeletePoliciesParams) =>
      bulkDeletePoliciesAPI(params),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['policies'] });
    },
  });
};
